import AccomplishmentMap from "@/components/home/AccomplishmentMap";
import DistinguishesUs from "@/components/home/DistinguishesUs";
import GlobalService from "@/components/home/GlobalService";
import HeroSection from "@/components/home/HeroSection";
import HomeContact from "@/components/home/HomeContact";
import MarketsWeSupport from "@/components/home/MarketsWeSupport";
import RegulatoryCarousel from "@/components/home/RegulatoryCarousel";
import Renowned from "@/components/home/Renowned";
import Team from "@/components/home/Team";
// import TestimonialsCarousel from "@/components/home/TestimonialsCarousel";
import WhyFDASection from "@/components/home/WhyFDASection";
function Home() {
  return (
    <div>
      <HeroSection />
      <GlobalService />
      <DistinguishesUs />
      <AccomplishmentMap />
      <RegulatoryCarousel />
      <MarketsWeSupport />
      <WhyFDASection />
      <Renowned />
      {/* <TestimonialsCarousel /> */}
      <Team />
      <HomeContact />
    </div>
  )
}

export default Home